import { useEffect, useState } from 'react';

/**
 * True below the given viewport width. Use where mobile needs a
 * STRUCTURALLY different render (not just CSS) — e.g. the rate rows
 * collapse to read-only cards with inline editing on phones.
 * Default 640px matches the rate-row card breakpoint.
 */
export function useIsMobile(maxWidth = 640): boolean {
   const query = `(max-width: ${maxWidth}px)`;
   // No matchMedia (tests, very old browsers): treat as a computer.
   const [isMobile, setIsMobile] = useState(
      () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches
   );
   useEffect(() => {
      if (typeof window.matchMedia !== 'function') return;
      const mq = window.matchMedia(query);
      const onChange = () => setIsMobile(mq.matches);
      onChange();
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
   }, [query]);
   return isMobile;
}
